import React from 'react';
import ProductSystemTableHeadRohr from './ProductSystemTableHeadRohr'
import ProductSystemTableHeadKabel from './ProductSystemTableHeadKabel'

const productSystemTableHead = (props) => {

  const components = {
          tube: ProductSystemTableHeadRohr,
          cable: ProductSystemTableHeadKabel,
      };

  const TableType = () => {
    const CompName = components[props.tableType]
    return <CompName onFilterTableColumnsAction={props.filterTableColumn} sortColumn={props.sortColumn} sortDirection={props.sortDirection} />
  };

  return TableType()
};

export default productSystemTableHead;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemTableHead.js